import request from "../../Requests/requests";
import { loadCountTask } from "../../store/StatisticsStore/TaskCounterReducer";
import { getCountPercentTask } from "../../store/StatisticsStore/TaskPercentCounterReducer";
import getDateUTC from "../../utils/getDateUTC";

export const getCountTime = () => {
    return async dispatch => {
        try {
            const response = await request.get('/Statistics/TaskCount/', {params: {
                UserId: localStorage.getItem('userID'),
                Date: getDateUTC(), 
            }})
            .then(response => response.data)
            .then(data => dispatch(loadCountTask(data)) && 
            dispatch(getCountPercentTask(data.totalTasks ? (data.completedTasks * 100) / data.totalTasks : 0)))
            const data = response.data;
            return data;
        }   catch (error) {
            throw error;
        }
    }
}